export default function SidebarBanners() {
  return (
    <div className="space-y-4">
      <a href="https://pokbet.vip" target="_blank" rel="noopener noreferrer">
        <img 
          src="https://www.zeankickoff1.com/images/Banner2568/200x400Sport.gif" 
          alt="Banner" 
          className="w-full h-auto"
        />
      </a>
      <a href="https://88club.co" target="_blank" rel="noopener noreferrer">
        <img 
          src="https://www.zeankickoff1.com/images/Banner2568/200x400-CPD-88CLUB-4.gif" 
          alt="Banner" 
          className="w-full h-auto"
        />
      </a>
      <a href="https://www.zeankickoff.com/3-เทพ-สเต็ปฮอท.html" target="_blank">
        <img 
          src="https://www.zeankickoff1.com/images/3tep-banner.gif" 
          alt="Tips Banner" 
          className="w-full h-auto"
        />
      </a>
      <a href="https://www.zeankickoff.com/ทีเด็ด-4-เซียน.html" target="_blank">
        <img 
          src="https://www.zeankickoff1.com/images/new-4-zean.gif" 
          alt="Analysis Banner" 
          className="w-full h-auto"
        />
      </a>
      <a href="https://www.zeankickoff.com/สำนักบอลเด็ด.html" target="_blank">
        <img 
          src="https://www.zeankickoff1.com/images/samnak-b.gif" 
          alt="Tips Banner" 
          className="w-full h-auto"
        />
      </a>
    </div>
  );
}